import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesLoading } from './Updates.loading';
import { UpdatesError } from './Updates.error';
import { UpdatesNewRaw } from './UpdatesNew.raw';

export type SortUpdatesNewTypes =
  | 'assignee'
  | 'priority'
  | 'subject'
  | 'affects'
  | 'date'
  | 'count'
  | 'pManufacturers'
  | undefined;

interface IUpdatesNewQuery {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesNewQuery = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesNewQuery) => {
  if (isLoading || !data) {
    return <UpdatesLoading />;
  }

  if (isError) {
    return <UpdatesError />;
  }

  return (
    <UpdatesNewRaw
      updateStatuses={data}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesNewQuery };
